import { Tooltip } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { addTestResult } from "../../api/addTestResult";
import goBackArrow from "../../assets/icon/goBackArrow.svg";
import placeholderIcon from "../../assets/icon/placeholderIcon.png";
import rightArrowIcon from "../../assets/icon/rightArrowIcon.svg";
import InfoAudio from "../../components/infoaudio/infoAudio";
import TestQues from "../../components/testQues/testQues";
import ZoomIn from "../../components/zoomIn/zoomIn";
import { getStudentData } from "../../helper/localStorage";
import {
  scoreCountMultiTap,
  totalTimeOrScore,
} from "../../helper/scoreCounter";
import { arrayValidation } from "../../helper/validation";
import { AnswerContext } from "../../store/answerStore";
import { HelperContext } from "../../store/helperStore";
import "./multiTap.scss";

export default function MultiTap({
  question,
  questions,
  index,
  handleDummySubmit,
}) {
  const [selectedAns, setSelectedAns] = useState([]);
  const { answerC, dispatchAnswer } = AnswerContext();
  const { helperC, dispatchHelper } = HelperContext();
  const [startTime, setStartTime] = useState();

  console.log("offSetHeight", helperC.offSetHeight);
  console.log("question.test_format", question.test_format);
  console.log("question", question);
  console.log("questions", questions);

  const isSingleTap =
    question.test_format === "single_tap" ||
    question.test_format === "single_tap_two" ||
    question.test_format === "listen_sound_differ" ||
    question.test_format === "visual_facename_mix" ||
    question.test_format === "dummy-test";

  //for styling width, text and image has different width
  const isText =
    question.info_audio === "sound_differentiation" ||
    question.info_audio === "text_matching" ||
    question.info_audio === "word_knowledge" ||
    question.info_audio === "word_comprehension" ||
    question.section_name === "FACE-NAME MIX" ||
    question.section_name === "DYSLEXIA 1(A)" ||
    question.test_format === "dummy-test";

  const isFNMix =
    question.section_name === "FACE-NAME MIX" ||
    question.test_format === "visual_facename_mix";
  const isDummyTest = question.test_format === "dummy-test";
  const fnAndDummy = isFNMix || isDummyTest;

  useEffect(() => {
    setStartTime(moment());
  }, []);

  const getTimeSpend = () => {
    const timeSpend = moment().diff(startTime);
    if (isFNMix) {
      return timeSpend;
    } else {
      return Math.floor(timeSpend / 1000);
    }
  };

  // creating array of tapped answer
  const handleMultiChoice = (answer, id) => {
    let ans = [...selectedAns];
   
    if (id === "190425225004") {
      if (ans.includes(answer)) {
        ans = ans.filter((ans) => ans !== answer);
        setSelectedAns(ans);
      } else {
        if (ans.length < 2) {
          ans = [...ans, answer];
          setSelectedAns(ans);
        } else {
          ans = ans.filter((ans, i) => i !== 1);
          ans = [...ans, answer];
          setSelectedAns(ans);
        }
      }
    } else {
      if (ans.includes(answer)) {
        ans = ans.filter((ans) => ans !== answer);
        setSelectedAns(ans);
      } else {
        ans = [...ans, answer];
        setSelectedAns(ans);
      }
    }
  };

  const handleSingleTap = (answer) => {
    setSelectedAns([answer]);
  };

  // sort and join tapped answer
  const sortAns = (value) => {
    return value
      .sort(function (a, b) {
        return a - b;
      })
      .join();
  };

  const answeredQues = () => {
    return {
      answer: arrayValidation(selectedAns) ? sortAns(selectedAns) : "",
      que_id: question.id,
      file_encoded: "",
      file_path: "",
      file_type: "",
      json_res: "",
      que_score: arrayValidation(selectedAns)
        ? scoreCountMultiTap(question, sortAns(selectedAns))
        : 0,
      que_time: getTimeSpend(),
      section_name: question.section_name,
    };
  };

  useEffect(() => {
    if (helperC.isNextQues) {
      dispatchHelper({ type: "IS_NEXT_QUES", payload: false });
      index < questions.length - 1
        ? handleNext(questions[index + 1])
        : handleSubmit();
    }
  }, [helperC.isNextQues]);

  const handleNext = (nextTest) => {
    if (helperC.testType === "CALIBRATION" && isDummyTest) {
      // return;
    } else {
      dispatchAnswer({
        type: "ADD_ANSWER",
        payload: answeredQues(),
      });
    }
    // }
    if (helperC.testType === "CALIBRATION" && fnAndDummy) {
      dispatchHelper({
        type: "FN_QUES_ID",
        payload: nextTest.id,
      });
    } else {
      dispatchHelper({
        type: "RUNNING_QUES_ID",
        payload: nextTest.id,
      });
    }
  };

  const handleSubmit = () => {
    if (question.test_format === "dummy-test") {
      // dummy test case
      handleDummySubmit(4); // 4 is step
      if (helperC.testType === "CALIBRATION" && fnAndDummy) {
        return;
      } else {
        dispatchAnswer({ type: "RESET_ANSWER" });
      }
    } else {
      if (helperC.testType === "CALIBRATION" && fnAndDummy) {
        dispatchAnswer({
          type: "ADD_ANSWER",
          payload: answeredQues(),
        });
        dispatchHelper({
          type: "RUNNING_QUES_ID",
          payload: JSON.parse(localStorage.getItem("SET_QUE_ID_AFTER_FN")),
        });
      } else {
        const answerRes = [...answerC.answers, answeredQues()];
        const { player_time, player_score } = totalTimeOrScore(
          answerRes,
          questions,
          isFNMix && "fnTest"
        );

        const grade_id =
          helperC.testType === "CALIBRATION"
            ? "5"
            : JSON.parse(localStorage.getItem("gradeId"));
        const { login_id } = getStudentData();
        const formatValue = {
          grade_id,
          player_id: login_id,
          res: answerRes,
          player_image: "",
          player_time,
          player_score,
          test_id: question.test_id,
        };
        dispatchAnswer({
          type: "ADD_ANSWER",
          payload: answeredQues(),
        });
        addTestResult(formatValue, dispatchHelper, dispatchAnswer);
      }
    }
  };

  const isActive = (choice) => {
    if (selectedAns.includes(choice)) {
      return "active";
    } else {
      return "";
    }
  };

  // const userChoice = (number, choice) => {
  const userChoice = (number, choice, id) => {
    return (
      <>
        {choice && (
          <div
            className={`multi-tap-ques-img-choice ${
              isText && "text"
            } ${isActive(number)}`}
            style={{}}
            onClick={() =>
              // isSingleTap ? handleSingleTap(number) : handleMultiChoice(number)
              isSingleTap
                ? handleSingleTap(number)
                : handleMultiChoice(number, id)
            }
          >
            {console.log("choice", choice)}
            {
              !!question.que_title1_type ? (
                <>
                  {question.test_format === "listen_sound_differ" ? ( // this is special case for sound differentiation test
                    choice.toLowerCase() === "no" ? (
                      <h1>SAME</h1>
                    ) : (
                      choice.toLowerCase() === "yes" && <h1>DIFFERENT</h1>
                    )
                  ) : (
                    <>
                      <h1 className={`${isFNMix && "fn-mix-choice"}`}>
                        {choice}
                      </h1>
                    </>
                  )}
                </>
              ) : // ) : (
              (choice.startsWith("http://") || choice.startsWith("https://") )? (
                <LazyLoadImage
                  placeholderSrc={placeholderIcon}
                  alt=""
                  effect="blur"
                  src={choice}
                />
              ) : (
                <h1>{choice}</h1>
              )

              //   <LazyLoadImage
              //     placeholderSrc={placeholderIcon}
              //     alt=""
              //     effect="blur"
              //     src={choice}
              //   />
              // )}
            }
            {/* {!isText  && <ZoomIn image={choice} />} */}
            {!isText && (choice.startsWith("http://") || choice.startsWith("https://"))&& <ZoomIn image={choice} />}
          </div>
        )}
      </>
    );
  };

  const getChoiceNum = (choice_2, choice_3, choice_4, choice_5, choice_6) => {
    console.log("numbernumber", choice_6);
    const number = !!choice_6
      ? 6
      : !!choice_5
      ? 5
      : !!choice_4
      ? 4
      : !!choice_3
      ? 3
      : !!choice_2
      ? 2
      : 1;

    const clsName =
      number <= 2
        ? "autoTwo"
        : number <= 3
        ? "autoThree"
        : number <= 4
        ? "autoTwo"
        : "autoThree";
    return clsName;
  };

  const isCalDemo =
    helperC.testType === "CALIBRATION" || helperC.testType === "DEMO";

  return (
    <>
      <div
        data-aos="zoom-in"
        className="test-body-content"
        style={{
          justifyContent: helperC.offSetHeight > 160 ? "initial" : "center",
        }}
      >
        <TestQues type="visualKeypad" question={question} />
        {isFNMix && <h4>Select correct one</h4>}
        {!isSingleTap && (
          <Tooltip title="Undo all">
            <img
              src={goBackArrow}
              alt=""
              className="goBack-icon"
              onClick={() => {
                setSelectedAns([]);
              }}
            />
          </Tooltip>
        )}

        <div
          className={`multi-tap-ques-img-choices 
          ${isFNMix && "with-grid"}
          ${isFNMix && isCalDemo && "twoAuto"}
          
          ${
            !isFNMix &&
            getChoiceNum(
              question.choice_2,
              question.choice_3,
              question.choice_4,
              question.choice_5,
              question.choice_6
            )
          }`}
        >
          {/* {userChoice("1", question.choice_1)}
          {userChoice("2", question.choice_2)}
          {userChoice("3", question.choice_3)}
          {userChoice("4", question.choice_4)}
          {userChoice("5", question.choice_5)}
          {userChoice("6", question.choice_6)}
          {userChoice("7", question.choice_7)}
          {userChoice("8", question.choice_8)}
          {userChoice("9", question.choice_9)}
          {userChoice("10", question.choice_10)}
          {userChoice("11", question.choice_11)}
          {userChoice("12", question.choice_12)} */}
          {userChoice("1", question.choice_1, question.test_id)}
          {userChoice("2", question.choice_2, question.test_id)}
          {userChoice("3", question.choice_3, question.test_id)}
          {userChoice("4", question.choice_4, question.test_id)}
          {userChoice("5", question.choice_5, question.test_id)}
          {userChoice("6", question.choice_6, question.test_id)}
          {userChoice("7", question.choice_7, question.test_id)}
          {userChoice("8", question.choice_8, question.test_id)}
          {userChoice("9", question.choice_9, question.test_id)}
          {userChoice("10", question.choice_10, question.test_id)}
          {userChoice("11", question.choice_11, question.test_id)}
          {userChoice("12", question.choice_12, question.test_id)}
        </div>
      </div>
      <div className="test-footer">
        <div className="test-footer__one" color="#ffc700">
          {!fnAndDummy && <InfoAudio question={question} />}
        </div>
        <div className="test-footer__two"></div>
        <div className="test-footer__three">
          <Tooltip
            title={
              !arrayValidation(selectedAns) && fnAndDummy
                ? "Please provide an answer"
                : !arrayValidation(selectedAns) &&
                  "Please select your answer first"
            }
          >
            <button
              htmlType="submit"
              onClick={() =>
                !arrayValidation(selectedAns)
                  ? undefined
                  : index < questions.length - 1
                  ? handleNext(questions[index + 1])
                  : handleSubmit()
              }
              // disabled={!arrayValidation(selectedAns)}
              className={`custom-btn footer ${
                !arrayValidation(selectedAns) && "disable"
              }`}
              // test-footer__btn-nonAudio
            >
              {index < questions.length - 1 ? "Next" : "Submit"}
              <img src={rightArrowIcon} alt="" />
            </button>
          </Tooltip>
        </div>
      </div>
    </>
  );
}
